import { SVGProps } from "react";

const ArrowDownIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0059 17.7782L21.4301 8.35393L20.5816 7.50541L12.0059 16.0811L3.43013 7.50541L2.5816 8.35393L12.0059 17.7782Z"
        fill="black"
      />
    </svg>
  );
};

export default ArrowDownIcon;
